import { FunctionComponent, useState } from 'react'

import { Icons } from 'atoms'
import { Product } from 'integration/resources/products'
import { Badge, Box, Heading, HStack, Image, Text, useMediaQuery, VStack } from 'native-base'

type Props = {
  product: Product
  horizontal?: boolean
}

export const ProductCardSearchDesktop: FunctionComponent<Props> = ({
  product: { image, name, description, price, slug, average_rating }
}) => {
  const [isSmallScreen] = useMediaQuery({
    minWidth: 1500
  })

  const [, setIsHovered] = useState(false)

  return (
    <VStack
      w={isSmallScreen ? '210px' : '180px'}
      position="relative"
      h="255px"
      borderRadius="10px"
      alignItems="center"
      //@ts-ignore
      cursor="pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <Box
        style={{
          shadowColor: 'rgba(0, 0, 0, 0.04)',
          shadowOpacity: 1,
          shadowRadius: 16,
          shadowOffset: { width: 0, height: 3 }
        }}>
        <Image
          source={image?.imageUrl ? { uri: image.imageUrl } : require('assets/not-found.png')}
          alt={image?.imageDescription ?? name}
          borderRadius="10px"
          h={isSmallScreen ? '172px' : '156px'}
          w={isSmallScreen ? '194px' : '175px'}
        />
      </Box>

      <HStack px={4} w="full" position="absolute" alignContent="space-between" top={2}>
        <Badge alignItems="center">
          <HStack alignItems="baseline">
            <Heading fontSize="12px" lineHeight="14px" fontWeight="bold" color="white" mr="2px">
              {price}
            </Heading>
            <Heading
              fontSize="10px"
              lineHeight="100%"
              fontWeight="normal"
              color="white"
              textTransform="uppercase">
              pts
            </Heading>
          </HStack>
        </Badge>
      </HStack>

      <VStack flex={1} w={isSmallScreen ? '194px' : '170px'}>
        <Heading
          fontSize="16px"
          lineHeight="24px"
          fontWeight="bold"
          color="gray.700"
          mt={4}
          numberOfLines={1}
          textAlign="center">
          {name}
        </Heading>

        <HStack mt="5px">
          {average_rating > 0 && (
            <HStack space={2}>
              <Icons.Star color="tertiary.500" size={21} filled />
              <Text
                fontSize="11px"
                alignContent="center"
                lineHeight="16px"
                marginRight="5px"
                fontWeight="400"
                color="tertiary.500">
                {average_rating}
              </Text>
            </HStack>
          )}
          <Text
            fontSize="12px"
            lineHeight="18px"
            fontWeight="normal"
            color="gray.500"
            numberOfLines={1}
            justifyContent="center"
            alignContent="center">
            {description}
          </Text>
        </HStack>
      </VStack>
    </VStack>
  )
}
